import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DashboardService } from "../../services/dashboard.service";
import { Tab } from "../../models/tabs.model";
import { Card } from "../../models/card.model";
import { forkJoin } from "rxjs";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user.model";
import { QuestionnaireService } from "../../services/questionnaire.service";
import { NavigationService } from "../../services/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-coordinator",
  templateUrl: "./coordinator.component.html",
  styleUrl: "./coordinator.component.scss",
})
export class CoordinatorComponent implements OnInit {
  donors: any[] = [];
  hoveredDonor: string | null = null;
  admins: User[] = [];

  selectedCardFilter: string | null = null;
  clearFiltersTrigger = false;
  incomingFilters: Record<string, string[]> = {};
  
  loading = true;
  dashboardTabs: Tab[] = [
    { text: "Donor Overview", name: "DonorOverview" },
    { text: "Reporting & Analytics", name: "Reporting" },
  ];

  stats = {
    totalPatients: 0,
    totalApprovedCandidates: 0,
    inReferral: 0,
    underEvaluation: 0,
    awaitingMRB: 0,
  };

  constructor(
    private dashboardService: DashboardService,
    private questionnaireService: QuestionnaireService,
    private navigationService: NavigationService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const state = this.navigationService.state;

    if (state?.appliedFilters) {
      this.incomingFilters = state.appliedFilters;
    }
    else{
      this.incomingFilters = {};
    }
    this.loadData();
    
    // if (this.dashboardTabs[0].name === 'DonorOverview') {
    //   window.location.hash = 'DonorOverview';
    // }
  }

  loadData() {
    this.loading = true;

    forkJoin({
      donors: this.dashboardService.getAllDonors(),
      admins: this.userService.getHospitalAdminUsers(),
    }).subscribe({
      next: ({ donors, admins }) => {
        this.donors = donors;

        const donorMetricsCalls = donors.map((donor) =>
          this.questionnaireService.getDonorMetrics(donor.email)
        );

        forkJoin(donorMetricsCalls).subscribe((metricsArray) => {
          this.donors.forEach((donor, index) => {
            donor.metrics = metricsArray[index];
          });
          
          this.loading = false;
        });

       
        this.updateStats(); // Update donor-related stats

        // Sort users by createdAt (newest first)
        this.admins = admins.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        this.admins = [...this.admins];

        this.loading = false;
      },
      error: (error) => {
        console.error("Error loading data:", error);
        this.loading = false;
      },
    });
  }

  updateStats() {
    this.stats.totalPatients = this.donors.length;
    this.stats.totalApprovedCandidates = this.donors.filter(
      (d) => d.dashboardStatus === "Approved"
    ).length;
    this.stats.inReferral = this.donors.filter(
      (d) => d.dashboardStatus === "In Referral"
    ).length;
    this.stats.underEvaluation = this.donors.filter(
      (d) => d.dashboardStatus === "Under Evaluation"
    ).length;
    this.stats.awaitingMRB = this.donors.filter(
      (d) => d.dashboardStatus === "Awaiting MRB"
    ).length;

    this.cdr.detectChanges();
  }

  
  onTabChange(selectedTab: string) {
    this.router.navigate([selectedTab.toLowerCase().replace(/ /g, "-")], {
      relativeTo: this.route,
    });
  }

  onActiveCardFilterChange(filterKey: string | null) {
    this.selectedCardFilter = filterKey;   
    this.cdr.detectChanges();
  }

  onClearFilters(){
    this.selectedCardFilter = null;
   
    this.clearFiltersTrigger = true;
    // Reset trigger to allow future toggles
    setTimeout(() => {
     
      // this.cdr.detectChanges();
      this.clearFiltersTrigger = false;
    });
  }
}
